<app-header [photo]="photo" [title]="title"></app-header>

<div class="wrapper">
  <h1 class="title is-1">UPCOMING SHOWS:

  </h1>


<ng-container *ngIf="filteredUpcomingShows.length > 0; else noShows">
  <h1 *ngFor="let x of filteredUpcomingShows" class="subtitle is-3">
    {{ x.date | date:'MMMM d, yyyy' }}
    <span class="subtitle is-3">
      {{ x.location }}
    </span>
  </h1>
</ng-container>

<ng-template #noShows>
  <p class="subtitle is-3 no-shows-message">No upcoming shows</p>
</ng-template>


  <hr id="endofsection">
  <h1 class="title is-1">PREVIOUS SHOWS</h1>


  <div [@listAnimation]="shows.length">

    <h1 *ngFor="let x of shows; index as i" class="subtitle is-3" id="date">
      <ng-container *ngIf="today > x.date">
        {{x.date | date:'MMMM d, yyyy'}}
        <span class="subtitle is-3">
          {{ x.location}}
        </span>
      </ng-container>
    </h1>
  </div>
</div>

<app-bottom></app-bottom>
